// Las posiciones se compactan en un solo paso, conservando los datos de cada instancia.
export const INSTANCE_MAP_FIELDS = ['responses', 'custom_subgroup_names', 'instance_states', 'instance_owners'];
export const INSTANCE_REFERENCE_FIELDS = ['excluded_from_report_fields', 'excluded_subgroup_instances',
    'excluded_manual', 'excluded_auto', 'hidden_response_fields'];

export function compactInstanceKey(key, groupIdx, removedIndices, count = Infinity) {
    const text = String(key);
    const state = text.match(/^g(\d+)_i(?:(\d+)_)?(\d+)$/);
    if (state && state[1] === String(groupIdx) && (!state[2] || state[2] === state[1])) {
        const index = Number(state[3]);
        if (index > count) return key;
        if (removedIndices.includes(index)) return null;
        return `g${groupIdx}_i${state[2] ? `${groupIdx}_` : ''}${index - removedIndices.filter(removed => removed < index).length}`;
    }
    const reserved = text.startsWith('_activo_id_') ? '_activo_id_' : text.startsWith('_gps_') ? '_gps_' : '';
    const value = reserved ? text.slice(reserved.length) : text;
    const prefix = `${groupIdx}_`;
    if (!value.startsWith(prefix)) return key;
    const match = value.slice(prefix.length).match(/^(\d+)(.*)$/);
    if (!match || (match[2] && !match[2].startsWith('_'))) return key;
    const index = Number(match[1]);
    if (index > count) return key;
    if (removedIndices.includes(index)) return null;
    const next = index - removedIndices.filter((removed) => removed < index).length;
    return `${reserved}${prefix}${next}${match[2]}`;
}

export function compactInstanceMap(map, groupIdx, indices, count = Infinity) {
    return Object.fromEntries(Object.entries(map || {}).flatMap(([key, value]) => {
        const next = compactInstanceKey(key, groupIdx, indices, count);
        return next === null ? [] : [[next, value]];
    }));
}

export function compactGroupSnapshot(source, { groupIdx, indices, count, baseMultiplier }) {
    const removed = [...new Set(indices)].sort((a, b) => b - a);
    if (!removed.length || removed.some((index) => !Number.isInteger(index) || index < 1 || index > count)
        || count - removed.length < baseMultiplier) {
        throw new Error('La cantidad a quitar supera las instancias adicionales disponibles.');
    }
    const result = JSON.parse(JSON.stringify(source));
    for (const name of INSTANCE_MAP_FIELDS) {
        if (result[name]) result[name] = compactInstanceMap(result[name], groupIdx, removed, count);
    }
    for (const name of INSTANCE_REFERENCE_FIELDS) {
        if (Array.isArray(result[name])) result[name] = result[name].map((key) => compactInstanceKey(key, groupIdx, removed, count)).filter((key) => key !== null);
        else if (result[name] && typeof result[name] === 'object') result[name] = compactInstanceMap(result[name], groupIdx, removed, count);
    }
    const dynamic = (result.dynamic_group_items || []).filter((item) => String(item.group_parent) !== String(groupIdx));
    const additionalCount = count - removed.length - baseMultiplier;
    if (additionalCount > 0) dynamic.push({ group_parent: String(groupIdx), additional_count: additionalCount });
    result.dynamic_group_items = dynamic;
    return result;
}

export function compactMediaMetadata(metadata, groupIdx, indices, count = Infinity) {
    if (!metadata?.instanceRef) return metadata;
    const instanceRef = compactInstanceKey(metadata.instanceRef, groupIdx, indices, count);
    return { ...metadata, instanceRef, ...(instanceRef === null ? { instanceLabel: null } : {}) };
}
